// extracted by mini-css-extract-plugin
module.exports = {"pool":"Pool_pool__1IJW3","icon":"Pool_icon__3i3I_","status":"Pool_status__3FW_i","border":"Pool_border__3mj_0","closed":"Pool_closed__1WEA0"};